import { render, staticRenderFns } from "./ProRetouchersOrderEducationHistory.vue?vue&type=template&id=0ef946bc&"
import script from "./ProRetouchersOrderEducationHistory.vue?vue&type=script&lang=js&"
export * from "./ProRetouchersOrderEducationHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProRetouchersOrderEducationHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports